import { FC } from 'react';

import { usePageTitleTranslation } from 'libs/navigation';

import { useNotificationSettings } from '../hooks';
import { NotificationsView } from '../views/NotificationsView';

export type NotificationsContainerProps = {};

export const NotificationsSettingsContainer: FC<
  NotificationsContainerProps
> = () => {
  const { submitLoading, initialValues, onSubmit } = useNotificationSettings();

  usePageTitleTranslation('settings.title');

  return (
    <NotificationsView
      initialValues={initialValues}
      submitLoading={submitLoading}
      onSubmit={onSubmit}
    />
  );
};
